<template>
  <div>
    <he :e-user="user"></he>
  </div>
</template>
<script>
import Header from './User/Header'
import axios from 'axios'
export default {
  data () {
    return {
      user: {}
    }
  },
  components: {
    He: Header
  },
  mounted () {
    axios.get(`/client/user/${this.$route.params.id}`)
      .then(r => {
        this.user = r.data.data
        document.title = `${this.user.username} :: Users :: PBN360 by Aphex Media`
      })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/ClientAccount/User.vue